import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { FaComments } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Drivers/DriverActiveRides/PickupCustomer.css";
import AppContext from "../../../context/AppContext";
import DriverMasterLayout from "../../../layouts/Drivers/DriverMasterLayout";

const PickupCustomer = () => {
  const navigate = useNavigate();
  const { selectedRideforFindingDriver, baseUrl, authToken, GOOGLE_API_KEY } =
    useContext(AppContext);
  const [pin, setPin] = useState("");
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const [pinError, setPinError] = useState("");
  const [mapLoading, setMapLoading] = useState(true);

  useEffect(() => {
    console.log("🔍 Ride Data:", selectedRideforFindingDriver);
    if (!selectedRideforFindingDriver) {
      console.warn("⚠️ No ride data found! Redirecting...");
    }
  }, [selectedRideforFindingDriver]);

  const handleBack = () => navigate(-1);
  const handleMessage = () => navigate("/driver-chat");

  const handleCall = () => {
    const phoneNumber =
      selectedRideforFindingDriver?.tdcustomer?.phoneNumber ||
      selectedRideforFindingDriver?.phoneNumber;

    if (!phoneNumber) {
      alert("📞 Phone number not available");
      return;
    }

    const isMobile = /Android|iPhone|iPad|iPod|Windows Phone/i.test(
      navigator.userAgent,
    );
    if (isMobile) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      navigator.clipboard
        .writeText(phoneNumber)
        .then(() => alert(`📋 Number copied: ${phoneNumber}`))
        .catch(() => alert(`📞 Number: ${phoneNumber}`));
    }
  };

  const handleStartRide = () => {
    if (!pin || pin.trim() === "") {
      setPinError("Please enter PIN first!");
      return;
    }
    const formData = new FormData();
    formData.append("tdride_id", selectedRideforFindingDriver?.id);
    formData.append("pin", pin);

    axios
      .post(`${baseUrl}/driver/ride/startRide`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log("Response:", response.data);
        if (response.data.success === true) {
          navigate("/ride-onway");
        } else {
          setPinError("Wrong PIN! Please try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        setPinError("Network Error! Please try again.");
      });
  };

  // ===== GOOGLE MAP (Leaflet removed) =====
  useEffect(() => {
    const loadGoogle = () =>
      new Promise((resolve) => {
        if (window.google) {
          resolve(window.google);
          return;
        }
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}`;
        script.onload = () => resolve(window.google);
        script.onerror = () => {
          console.warn("⚠️ Google Maps API failed to load");
          resolve(null);
        };
        document.head.appendChild(script);
      });

    loadGoogle().then((google) => {
      if (!mapRef.current || !google) {
        setMapLoading(false);
        return;
      }

      const lat = parseFloat(selectedRideforFindingDriver?.pickupLat);
      const lng = parseFloat(selectedRideforFindingDriver?.pickupLng);
      const hasValidCoords = !isNaN(lat) && !isNaN(lng);
      const center = hasValidCoords
        ? { lat, lng }
        : { lat: 31.5204, lng: 74.3587 };

      if (!hasValidCoords) {
        console.warn(
          "⚠️ pickupLat/pickupLng missing in ride data, showing default location",
        );
      }

      const map = new google.maps.Map(mapRef.current, {
        center,
        zoom: 15,
        disableDefaultUI: true,
        zoomControl: true,
      });

      mapInstanceRef.current = map;
      setMapLoading(false);

      if (hasValidCoords) {
        new google.maps.Marker({
          position: center,
          map,
          title:
            selectedRideforFindingDriver?.pickuplocation || "Pickup location",
        });
      }
    });

    return () => {
      mapInstanceRef.current = null;
    };
  }, [selectedRideforFindingDriver, GOOGLE_API_KEY]);

  // Data validation
  if (!selectedRideforFindingDriver) {
    return (
      <DriverMasterLayout showHeader={false}>
        <div
          className="pickup-customer-container d-flex align-items-center justify-content-center"
          style={{ minHeight: "100vh" }}
        >
          <Container>
            <div className="text-center">
              <h3>No ride selected</h3>
              <p className="text-muted">Please select a ride first</p>
              <Button onClick={() => navigate(-1)}>Go Back</Button>
            </div>
          </Container>
        </div>
      </DriverMasterLayout>
    );
  }

  const customerName =
    selectedRideforFindingDriver?.tdcustomer?.customerName || "Customer";
  const customerImage =
    selectedRideforFindingDriver?.tdcustomer?.customer_image;
  const rating = selectedRideforFindingDriver?.rating || 5.0;
  const totalRides = selectedRideforFindingDriver?.totalRides || 0;
  const pickupLocation = (() => {
    console.log("🔍 Ride Data:", selectedRideforFindingDriver);
    console.log(
      "📍 Pickup Location:",
      selectedRideforFindingDriver?.pickuplocation,
    );
    return selectedRideforFindingDriver?.pickuplocation || "Pickup location";
  })();

  return (
    <DriverMasterLayout showHeader={false}>
      <div className="pickup-customer-container">
        {/* ===== MAP ===== */}
        <div className="pickup-customer-map">
          <Button className="pickup-customer-back-btn" onClick={handleBack}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M19 12H5M12 19l-7-7 7-7"
                stroke="#000"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Button>
          {mapLoading && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1,
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            >
              <p>Loading map...</p>
            </div>
          )}
          <div ref={mapRef} className="pickup-customer-map-canvas" />
        </div>

        {/* ===== BOTTOM SHEET ===== */}
        <div className="pickup-customer-bottom-sheet">
          <div className="pickup-customer-scroll-area">
            <Container>
              {/* Customer Header */}
              <Row className="align-items-center mb-3 pb-3 pickup-customer-header-border">
                <Col xs="auto">
                  <div className="pickup-customer-avatar">
                    {customerImage ? (
                      <img src={customerImage} alt={customerName} />
                    ) : (
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "50%",
                          backgroundColor: "#1B9B82",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        {customerName.charAt(0).toUpperCase()}
                      </div>
                    )}
                  </div>
                </Col>
                <Col>
                  <h3 className="pickup-customer-name mb-1">{customerName}</h3>
                  <div className="pickup-customer-stats">
                    <span className="pickup-customer-rating">★ {rating}</span>
                    <span className="pickup-customer-rides ms-1">
                      ({totalRides})
                    </span>
                  </div>
                </Col>
                <Col xs="auto">
                  <div className="d-flex gap-2">
                    <Button
                      className="pickup-customer-icon-btn pickup-customer-message-btn p-0"
                      onClick={handleMessage}
                    >
                      <FaComments size={18} />
                    </Button>
                    <Button
                      className="pickup-customer-icon-btn pickup-customer-call-btn p-0"
                      onClick={handleCall}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 5.19 12.9a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                          fill="currentColor"
                        />
                      </svg>
                    </Button>
                  </div>
                </Col>
              </Row>

              {/* Pickup Location */}
              <div className="pickup-customer-location mb-3 p-3">
                <Row className="align-items-start">
                  <Col xs="auto">
                    <div className="pickup-customer-location-icon">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                          fill="#1B9B82"
                        />
                        <circle cx="12" cy="10" r="3" fill="white" />
                      </svg>
                    </div>
                  </Col>
                  <Col>
                    <p className="pickup-customer-location-label mb-1">
                      Pickup Location
                    </p>
                    <p className="pickup-customer-location-address mb-0">
                      {pickupLocation}
                    </p>
                  </Col>
                </Row>
              </div>

              {/* OTP Input */}
              <Form.Group className="mb-2">
                <Form.Label className="pickup-customer-pin-label">
                  Enter PIN
                </Form.Label>
                <Form.Control
                  type="text"
                  value={pin}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 4) {
                      setPin(value);
                      setPinError("");
                    }
                  }}
                  className="pickup-customer-pin-input"
                  placeholder="Enter 4-digit PIN"
                  style={{ textTransform: "none" }}
                />
              </Form.Group>
              {pinError && (
                <p
                  style={{
                    color: "#dc3545",
                    fontSize: "13px",
                    marginTop: "4px",
                  }}
                >
                  {pinError}
                </p>
              )}
            </Container>
          </div>

          {/* START RIDE BUTTON */}
          <div className="pickup-customer-btn-wrapper">
            <Container>
              <Button
                className="pickup-customer-accept-btn w-100"
                onClick={handleStartRide}
              >
                Start Ride
              </Button>
            </Container>
          </div>
        </div>
      </div>
    </DriverMasterLayout>
  );
};

export default PickupCustomer;
  